import _extends from '@babel/runtime/helpers/extends';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React__default, { useState, useEffect, useImperativeHandle, useRef } from 'react';
import './Datepicker.scss.js';
import { parseToFormat, getWeekDay, generateMask, stringToDate, formatDate } from '../../../utils/helpersDatePicker.js';
import { Manager, Reference } from 'react-popper';
import Input from '../Input/Input.js';
import InputMask from 'react-input-mask';
import { classnames } from '../../../utils/classnames.js';
import Dropdown from '../Dropdown/index.js';
import DatepickerCalendar from './DatepickerCalendar/DatepickerCalendar.js';
import TrapFocus from '../TrapFocus/TrapFocus.js';
import AllCalendar from '../../../assets/icons/resultDir/AllCalendar.js';
import AllClose from '../../../assets/icons/resultDir/AllClose.js';
import ArrowsChevronDown from '../../../assets/icons/resultDir/ArrowsChevronDown.js';

var Datepicker = function Datepicker(_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'datepicker' : _ref$name,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'ru' : _ref$locale,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? locale === 'ru' ? 'Выберите дату' : 'Select date' : _ref$placeholder,
      defaultValue = _ref.defaultValue,
      min = _ref.min,
      max = _ref.max,
      _ref$invalid = _ref.invalid,
      invalid = _ref$invalid === void 0 ? false : _ref$invalid,
      _ref$filled = _ref.filled,
      filled = _ref$filled === void 0 ? true : _ref$filled,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      onChange = _ref.onChange,
      _ref$range = _ref.range,
      range = _ref$range === void 0 ? false : _ref$range,
      _ref$showDayOfWeek = _ref.showDayOfWeek,
      showDayOfWeek = _ref$showDayOfWeek === void 0 ? false : _ref$showDayOfWeek,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottom-start' : _ref$position,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? 'dd.mm.yyyy' : _ref$format,
      _ref$disableWeekDays = _ref.disableWeekDays,
      disableWeekDays = _ref$disableWeekDays === void 0 ? [0, 6] : _ref$disableWeekDays,
      children = _ref.children,
      _ref$tooltipBackgroun = _ref.tooltipBackground,
      tooltipBackground = _ref$tooltipBackgroun === void 0 ? 'white' : _ref$tooltipBackgroun,
      containerRef = _ref.containerRef,
      controlRef = _ref.controlRef,
      _ref$isFocusBorder = _ref.isFocusBorder,
      isFocusBorder = _ref$isFocusBorder === void 0 ? false : _ref$isFocusBorder;
  var separator = format[2];

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      dayOfWeek = _useState2[0],
      setDayOfWeek = _useState2[1];

  var _useState3 = useState(undefined),
      _useState4 = _slicedToArray(_useState3, 2),
      minDate = _useState4[0],
      setMinDate = _useState4[1];

  var _useState5 = useState(undefined),
      _useState6 = _slicedToArray(_useState5, 2),
      maxDate = _useState6[0],
      setMaxDate = _useState6[1];

  useEffect(function () {
    setMinDate(min ? parseToFormat(format, min).date : undefined);
  }, [min]);
  useEffect(function () {
    setMaxDate(max ? parseToFormat(format, max).date : undefined);
  }, [max]);
  useImperativeHandle(controlRef, function () {
    return {
      reset: function reset() {
        return clearDateRangeHandler();
      }
    };
  }); // -------------------------------------------------------------------------------------------------------------------

  var datepickerRef = useRef(null);
  var inputRef = useRef(null);

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      showCalendar = _useState8[0],
      toggleCalendar = _useState8[1];

  var onClose = function onClose() {
    return toggleCalendar(false);
  }; // -------------------------------------------------------------------------------------------------------------------


  var _useState9 = useState(''),
      _useState10 = _slicedToArray(_useState9, 2),
      inputValue = _useState10[0],
      setInputValue = _useState10[1];

  var validate = function validate(date) {
    var result = date;

    if (range) {
      var _date$split = date.split(' - '),
          _date$split2 = _slicedToArray(_date$split, 2),
          from = _date$split2[0],
          to = _date$split2[1];

      var fromD = 0;
      var toD = 0;

      if (from) {
        from = from.slice(0, 10);
      }

      if (to) {
        to = to.slice(0, 10);
      }

      if (from && !from.includes('_')) {
        fromD = stringToDate(from, format).getTime();

        if (minDate && fromD < minDate.getTime()) {
          fromD = minDate.getTime();
        }

        if (maxDate && fromD > maxDate.getTime()) {
          fromD = minDate ? minDate.getTime() : maxDate.getTime();
        }

        from = formatDate(fromD, format).date;
      }

      if (to && !to.includes('_')) {
        toD = stringToDate(to, format).getTime();

        if (toD < fromD) {
          toD = fromD + 24 * 3600 * 1000;
        }

        if (maxDate && toD > maxDate.getTime()) {
          toD = maxDate.getTime();
        }

        to = formatDate(toD, format).date;
      }

      if (from || to) {
        result = [from, to].join(' - ');
      }
    } else {
      var d = stringToDate(date, format);

      if (date !== '' && minDate && d.getTime() < minDate.getTime()) {
        result = formatDate(minDate.getTime(), format).date;
      }

      if (maxDate && d.getTime() > maxDate.getTime()) {
        result = formatDate(maxDate.getTime(), format).date;
      }
    }

    return result;
  };

  useEffect(function () {
    if (!defaultValue) {
      return;
    }

    var inputValue = parseToFormat(format, defaultValue).string;

    if (!inputValue.includes('_')) {
      inputValue = validate(parseToFormat(format, defaultValue).string);
    }

    setInputValue(inputValue);
  }, [defaultValue, minDate, maxDate]); // -------------------------------------------------------------------------------------------------------------------

  var getReturnValue = function getReturnValue(value, range) {
    if (range) {
      var _value$split = value.split(' - '),
          _value$split2 = _slicedToArray(_value$split, 2),
          from = _value$split2[0],
          to = _value$split2[1];

      var fromD = stringToDate(from, format).getTime();
      var toD = stringToDate(to, format).getTime();
      var fromUTCD = stringToDate(from, format, true).getTime();
      var toUTCD = stringToDate(to, format, true).getTime();
      return {
        value: value,
        date: {
          from: new Date(fromD),
          to: new Date(toD),
          value: new Date(fromD)
        },
        timestamp: {
          from: fromD,
          to: toD,
          value: fromD,
          utc: {
            from: fromUTCD,
            to: toUTCD,
            value: fromUTCD
          }
        }
      };
    }

    var date = stringToDate(value, format);
    var dateUTC = stringToDate(value, format, true);
    return {
      date: {
        from: date,
        to: date,
        value: date
      },
      value: value,
      timestamp: {
        from: date.getTime(),
        to: date.getTime(),
        value: date.getTime(),
        utc: {
          from: dateUTC.getTime(),
          to: dateUTC.getTime(),
          value: dateUTC.getTime()
        }
      }
    };
  };

  var updateValue = function updateValue(value) {
    if (!value.includes('_') && value !== '') {
      var formattedResult = getReturnValue(value, range);
      onChange === null || onChange === void 0 ? void 0 : onChange(formattedResult, name);
      fireOnChange();
    } else if (value === '__.__.____') {
      var _formattedResult = getReturnValue('', range);

      onChange === null || onChange === void 0 ? void 0 : onChange(_formattedResult, name);
      fireOnChange();
    } else if (showDayOfWeek) {
      setDayOfWeek([]);
    }

    setInputValue(value);
  };

  var handleInputChange = function handleInputChange(e) {
    var value = e.target.value;

    if (range || value.length === 10 && !value.includes('_')) {
      value = validate(value);
    }

    updateValue(value);
  };

  var handleCalendarClick = function handleCalendarClick(value) {
    updateValue(validate(value));
  };

  var fireOnChange = function fireOnChange() {
    setTimeout(function () {
      if (inputRef.current) {
        var input = inputRef.current.querySelector('input');

        if (input) {
          var event;

          if (typeof Event === 'function') {
            event = new Event('change');
          } else {
            event = document.createEvent('Event');
            event.initEvent('change', true, true);
          }

          input.dispatchEvent(event);
        }
      }
    }, 100);
  }; // -------------------------------------------------------------------------------------------------------------------


  useEffect(function () {
    if (showDayOfWeek) {
      if (!range) {
        if (!inputValue.includes('_') && inputValue !== '') {
          var result = getReturnValue(inputValue, range);
          var dayFrom = result.date.value.getDay();
          setDayOfWeek([getWeekDay(dayFrom, locale)]);
        }
      } else {
        var _inputValue$split = inputValue.split(' - '),
            _inputValue$split2 = _slicedToArray(_inputValue$split, 2),
            fromValue = _inputValue$split2[0],
            toValue = _inputValue$split2[1];

        if (fromValue && !fromValue.includes('_')) {
          var from = getReturnValue(fromValue, false);

          var _dayFrom = from.date.from.getDay();

          setDayOfWeek([getWeekDay(_dayFrom, locale)]);
        }

        if (toValue && !toValue.includes('_')) {
          var to = getReturnValue(toValue, false);
          var dayTo = to.date.from.getDay();
          setDayOfWeek([].concat(_toConsumableArray(dayOfWeek), [getWeekDay(dayTo, locale)]));
        }
      }
    }
  }, [inputValue, showDayOfWeek, range]); // -------------------------------------------------------------------------------------------------------------------

  var onKeyPress = function onKeyPress(e) {
    if (e.key.toLowerCase() === 'enter' || e.charCode === 13) {
      e.stopPropagation();
      e.preventDefault();
    }
  };

  var clearDateRangeHandler = function clearDateRangeHandler() {
    setInputValue('');
    var result = getReturnValue('', range);
    onChange && onChange(result, name);
    fireOnChange();
  };

  var handleEscapePress = function handleEscapePress(e) {
    if (e.key === 'Escape') {
      e.stopPropagation();
      onClose();
    }
  }; // -------------------------------------------------------------------------------------------------------------------


  var mask = generateMask(inputValue, format, range, showDayOfWeek, dayOfWeek); // -------------------------------------------------------------------------------------------------------------------

  var isCrossChevronPicker = inputValue.split('-').length === 2 && inputValue.split('-')[1].trim() !== '__.__.____';
  return /*#__PURE__*/React__default.createElement(Manager, {
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classnames('rf-datepicker', isFocusBorder && 'rf-datepicker__focus-border', disabled && 'rf-datepicker--disabled'),
    ref: datepickerRef,
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement(Reference, {
    "data-v-6e52f9c7": ""
  }, function (referenceProps) {
    return /*#__PURE__*/React__default.createElement("div", _extends({}, referenceProps, {
      className: classnames('rf-datepicker__input-wrapper', {
        'rf-datepicker__input-wrapper--disabled': disabled,
        'rf-datepicker__input-wrapper--readonly': readOnly,
        'rf-datepicker__input-wrapper--range': range
      }),
      onClick: function onClick() {
        return toggleCalendar(function (prev) {
          return !prev;
        });
      },
      "data-v-6e52f9c7": ""
    }), children || /*#__PURE__*/React__default.createElement(InputMask, {
      mask: mask,
      name: name,
      placeholder: placeholder,
      value: inputValue,
      disabled: disabled,
      readOnly: readOnly,
      onKeyPress: onKeyPress,
      onChange: handleInputChange,
      "data-v-6e52f9c7": ""
    }, /*#__PURE__*/React__default.createElement(Input, {
      disabled: disabled,
      invalid: invalid,
      filled: filled,
      startAdornment: /*#__PURE__*/React__default.createElement("div", {
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        className: "rf-datepicker__calendar-button",
        "data-v-6e52f9c7": ""
      }, /*#__PURE__*/React__default.createElement(AllCalendar, {
        "data-v-6e52f9c7": ""
      })),
      endAdornment: /*#__PURE__*/React__default.createElement("div", {
        className: classnames('rf-datepicker__calendar-chevron', isCrossChevronPicker && 'rf-datepicker__calendar-cross'),
        "data-v-6e52f9c7": ""
      }, isCrossChevronPicker ? /*#__PURE__*/React__default.createElement("div", {
        className: "rf-datepicker__icon-wrapper",
        "data-v-6e52f9c7": ""
      }, /*#__PURE__*/React__default.createElement(AllClose, {
        onClick: clearDateRangeHandler,
        "data-v-6e52f9c7": ""
      })) : /*#__PURE__*/React__default.createElement(ArrowsChevronDown, {
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        "data-v-6e52f9c7": ""
      })),
      "data-v-6e52f9c7": ""
    })));
  }), /*#__PURE__*/React__default.createElement(Dropdown, {
    show: showCalendar,
    toggleRef: datepickerRef,
    onClose: onClose,
    position: position,
    strategy: "fixed",
    style: {
      maxWidth: 'auto',
      width: 'auto'
    },
    containerRef: containerRef,
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement(TrapFocus, {
    open: true,
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement("div", {
    tabIndex: -1,
    className: "rf-datepicker__date-picker-container",
    onKeyUp: handleEscapePress,
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement(DatepickerCalendar, {
    value: inputValue,
    minDate: minDate,
    maxDate: maxDate,
    setInputValue: handleCalendarClick,
    range: range,
    locale: locale,
    toggleCalendar: toggleCalendar,
    separator: separator,
    format: format,
    disableWeekDays: disableWeekDays || [],
    tooltipBackground: tooltipBackground,
    "data-v-6e52f9c7": ""
  }))))));
};

export { Datepicker as default };
